import { forwardRef, useCallback } from 'react';
import {
  Link as RouterLink,
  LinkProps,
  Navigate,
  NavigateProps,
  To,
  useNavigate,
  NavigateOptions,
} from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { localizeTo } from '@/lib/localeRouting';

const LocalizedLink = forwardRef<HTMLAnchorElement, LinkProps>(({ to, ...props }, ref) => {
  const { lang } = useLanguage();
  return <RouterLink ref={ref} to={localizeTo(to, lang)} {...props} />;
});

LocalizedLink.displayName = 'LocalizedLink';

function LocalizedNavigate({ to, ...props }: NavigateProps) {
  const { lang } = useLanguage();
  return <Navigate to={localizeTo(to, lang)} {...props} />;
}

function useLocalizedNavigate() {
  const navigate = useNavigate();
  const { lang } = useLanguage();

  return useCallback(
    (to: To, options?: NavigateOptions) => {
      navigate(localizeTo(to, lang), options);
    },
    [navigate, lang],
  );
}

export { LocalizedLink as Link, LocalizedNavigate as Navigate, useLocalizedNavigate };
